module.exports = __webpack_public_path__ + "static/ultrassom-e08fc74dc9e0d45f66214e8c31124a4e.jpg";